export default __webpack_public_path__ + "54d390c4bde2a903f57cc6ff476ae3e7.jpeg";